// `ExtensionAlertCandidatesMessageParamValidationService`
// (`…/extension-alert-candidates-message/service/extension-alert-candidates-message-param-validation.service.ng1.ts`),
// ported. Upstream: woo@10e2fe0302.
//
// A `{token}` the server does not know is sent LITERALLY — "Hi {Frist name}" reaches the
// candidate with the braces in it — so every unknown one is a reason to refuse.

/** Every token a message may carry when it is sent from an alert. */
const VALID_PARAMETERS: ReadonlySet<string> = new Set([
  'Candidate first name', // backward compatibility
  'First name',
  'Hunter name',
])

/** Without an alert there is no hunter to name, so `{Hunter name}` is unknown in a BODY. */
const VALID_PARAMETERS_ALERTLESS: ReadonlySet<string> = new Set([
  'Candidate first name', // backward compatibility
  'First name',
])

function findInvalidParameters(
  stringsToCheck: ReadonlyArray<string | null | undefined>,
  valid: ReadonlySet<string>,
): string[] {
  const invalid: string[] = []
  for (const text of stringsToCheck) {
    // Upstream passes the value straight to `regex.exec`, which stringifies a null to "null" —
    // no braces, so no tokens. Same answer, without relying on the coercion.
    for (const found of (text ?? '').matchAll(/\{(.*?)\}/g)) {
      const name = found[1] ?? ''
      if (!valid.has(name)) invalid.push(name)
    }
  }
  return invalid
}

/** `checkParameterValidity` — the subject, body and follow-ups. Returns each unknown token. */
export function checkParameterValidity(
  stringsToCheck: ReadonlyArray<string | null | undefined>,
  alertless: boolean,
): string[] {
  return findInvalidParameters(stringsToCheck, alertless ? VALID_PARAMETERS_ALERTLESS : VALID_PARAMETERS)
}

/**
 * `checkSignatureParameterValidity` — the signature, ALWAYS against the alert set.
 *
 * ⚠️ NOT `checkParameterValidity([signature], !alertId)`, which is what it replaced. One saved
 * signature goes out with and without an alert (`{Hunter name}` renders empty without one), so
 * whether it can be saved must not depend on which screen the editor happened to be opened on.
 * The old call rejected a signature on one screen that the other had saved.
 */
export function checkSignatureParameterValidity(signature: string | null | undefined): string[] {
  return findInvalidParameters([signature], VALID_PARAMETERS)
}
